import script from "./PodcastersList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastersList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastersList.vue?vue&type=style&index=0&id=aed0bd2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aed0bd2e"]])

export default __exports__